import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import SiteWrapper from '../components/sitewrapper'
import Layout from '../components/layout'
import WebsitePicker from '../components/website-picker'

export default function ConnectWebsite(): React.ReactElement {
  const oauth = useSelector((state: any): any => state.oauth)
  const { credentials } = oauth
  const history = useHistory()

  useEffect(() => {
    // there are no credentials, we need to get them again
    if (credentials === '') {
      // Force Google reconnect
      history.push('/connect')
    }
    // eslint-disable-next-line
  }, [credentials])

  return (
    <SiteWrapper skeleton justLogo>
      <Layout width={1200}>
        <WebsitePicker />
      </Layout>
    </SiteWrapper>
  )
}
